import { ReactElement, useEffect, useState } from "react";
import { IChartWrapperProps } from "../../types";
import { IStackerAreaChartConfig } from "../../../../components/charts/types";
import StackedLineChart from "../../../../components/charts/stackedLineChart";
import { getGenericChartConfig } from "./utils";

const StackedLineChartWrapper = ({ cell, data, parentSize, palette, updatePalette, node, schemas }: IChartWrapperProps): ReactElement => {
  const [ chartConfig, setChartConfig ] = useState<IStackerAreaChartConfig | null>(null);

  useEffect(() => {
    if (data) {
      const [ series, xAxis, yAxes ] = getGenericChartConfig(data, cell, node, palette, updatePalette, schemas);

      setChartConfig({
        height: parentSize.height,
        series,
        xAxis,
        yAxis: yAxes[0],
        showLegend: true
      });
    }
  }, [ cell, data, parentSize, palette, updatePalette, node, schemas ]);

  return (
    <div className="display-grid" style={{ ...parentSize }}>
      {chartConfig && <StackedLineChart chartConfig={chartConfig}/>}
    </div>
  );
};

export default StackedLineChartWrapper;
